const delay = 500

export function handleResponse (handleMsg) {
  return function (response) {
    console.group('response')
    console.log(response)
    console.groupEnd()
    return new Promise(((resolve, reject) => {
      setTimeout(function () {
        let reason = ''
        if (`${response.status}` !== '200') {
          reason = `status code: ${response.status}`
        } else if (response.data === undefined) {
          reason = `response doesn't has any data`
        } else if (`${response.data.code}` !== '200') {
          const defaultMsg = process.env['REACT_APP_BUILD_ENV'] === 'production'
            ? response.data['msg']
            : `response code: ${response.data['code']}, ${response.data['msg']}`
          reason = handleMsg ? handleMsg({ ...response.data, defaultMsg }) : defaultMsg
        } else {
          //  success
          resolve(response.data['data'])
        }
        reject(reason)
        //  防止请求过快，页面loading闪屏...
      }, delay)
    })).then(result => result,
      reason => {
        throw Error(reason)
      })
  }
}
